export const formatDisplayDate = (input) => {
  let date;
  if(!input) return null; 

  // Handle different input types
  if (input instanceof Date) {
    date = input;
  } else if (typeof input === 'string') {
    date = new Date(input);
  } else if (typeof input === 'number') {
    date = new Date(input);
  } else {
    throw new Error('Invalid input: expected Date object, string, or number');
  }
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date: could not parse input');
  }
  
  // Format the date
  const options = {
    weekday: 'short',  // 'Fri'
    month: 'short',    // 'Sep'
    day: 'numeric',    // '12'
    year: 'numeric'    // '2025'
  };
  
  return date.toLocaleDateString('en-US', options);
};

export const formatShipDate = (input) => {
  let date;
  if(!input) return null; 

  // Handle different input types
  if (input instanceof Date) {
    date = input;
  } else if (typeof input === 'string') {
    // Handle ISO date strings by extracting just the date part
    if (input.includes('T') || input.includes('Z')) {
      // Extract date portion (YYYY-MM-DD) and create date in local timezone
      const datePart = input.split('T')[0];
      const [year, month, day] = datePart.split('-').map(Number);
      date = new Date(year, month - 1, day); // month is 0-indexed
    } else {
      date = new Date(input);
    }
  } else if (typeof input === 'number') {
    date = new Date(input);
  } else {
    throw new Error('Invalid input: expected Date object, string, or number');
  }
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date: could not parse input');
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

export const calcNextShipDate = (fromDate = new Date()) => {
  const date = new Date(fromDate);
  
  // Add one day
  date.setDate(date.getDate() + 1);

  // Skip weekends (Saturday = 6, Sunday = 0)
  while(date.getDay() === 0 || date.getDay() === 6) {
    date.setDate(date.getDate() + 1);
  }

  return date;
}

export const calcNextDeliveryDate = (fromDate = new Date()) => {
  const date = new Date(fromDate);
  
  // Add one day
  date.setDate(date.getDate() + 1);

  // Skip weekends (Saturday = 6, Sunday = 0)
  while(date.getDay() !== 5) {
    date.setDate(date.getDate() + 1);
  }

  return date;
}

export const calcDeliverByDate = (fromDate = new Date()) => {
  const date = new Date(fromDate);

  for(let days = 0; days < 3; days++) {
    date.setDate(date.getDate() - 1);

    // Skip weekends (Saturday = 6, Sunday = 0)
    while(date.getDay() === 0 || date.getDay() === 6) {
      date.setDate(date.getDate() - 1);
    }
  }

  return date;
}

export const calcDefaultShipDate = (fromDate = new Date()) => {
  const date = new Date(fromDate);
  
  // Get the current day of the week (0 = Sunday, 1 = Monday, etc.)
  const currentDay = date.getDay();
  
  // Calculate days until next Monday
  const daysUntilMonday = currentDay === 0 ? 1 : (8 - currentDay);
  
  // Add days to get to next Monday, then add 14 more days (2 weeks)
  date.setDate(date.getDate() + daysUntilMonday + 14);
  
  return date;
}

export const calcDefaultDeliveryDate = (fromDate = new Date()) => {
  const date = new Date(fromDate);
  
  // Get the current day of the week (0 = Sunday, 1 = Monday, etc.)
  const currentDay = date.getDay();

  // Calculate days until next Friday
  const daysUntilDay = currentDay === 0 ? 1 : (5 - currentDay);

  // Add days to get to next Friday, then add 14 more days (2 weeks)
  date.setDate(date.getDate() + daysUntilDay + 14);

  return date;
}